<template>
  <v-app id="inspire">
    <div class="inventory-reports-wrap">
      <v-layout class="inv-top-header mb-4">
        <v-flex>
          <p class="text-uppercase caption mb-0">Reports</p>
          <h2 class="headline">Work Area Inventory</h2>
        </v-flex>
      </v-layout>

      <v-flex class="header-search-single">
        <v-container class="grid-list-md pa-0 mb-4 container--fluid">
          <v-layout class="wrap xs12">  
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-menu
                ref="menu1"
                :label="`From Date`"
                v-model="menu1"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="start_date"
                    :label="`From Date`"
                    persistent-hint
                    prepend-icon="event"
                    placeholder="Please Select"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="start_date"
                  no-title
                  :min="minDate"
                  :max="maxDate"
                  @input="menu1 = false"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
              <v-menu
                ref="menu2"
                :label="`To Date`"
                v-model="menu2"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="end_date"
                    :label="`To Date`"
                    persistent-hint
                    prepend-icon="event"
                    placeholder="Please Select"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="end_date"
                  no-title
                  :min="minDate"
                  :max="maxDate"
                  @input="menu2 = false"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-btn
                large
                color="primary"
                dark
                class="mx-0 mt-1 mb-2"
                style="min-width: 50px; padding: 0 10px;"
                @click="applyFilters"
              >
                Apply
              </v-btn>
            </v-flex>
            <v-flex class="xs12 pa-0">
              <v-alert class="pa-2 mt-2" :value="!no_data.includes(dateError)" outlined color="error" icon="priority_high" transition="scale-transition">
                <span class="caption">{{ dateError }}</span>
              </v-alert>
            </v-flex>
            <v-flex class="xs12 my-0">
              <span
                @click="resetFilters"
                class="clear-filters"
                >Reset Filters</span
              >
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-lazy
        :options="{ threshold: .5 }"
        min-height="197"
        transition="fade-transition"
      >
        <inventory-per-work-area :start_date="start_date_value" :end_date="end_date_value" :clients="clients" :dateError="dateError"></inventory-per-work-area>
      </v-lazy>
      <v-lazy
        :options="{ threshold: .5 }"
        min-height="197"
        transition="fade-transition"
      >
        <inventory-per-client :start_date="start_date_value" :end_date="end_date_value" :clients="clients" :dateError="dateError"></inventory-per-client>
      </v-lazy>
      <v-lazy
        :options="{ threshold: .5 }"
        min-height="197"
        transition="fade-transition"
      >
        <inventory-per-cross-sell :start_date="start_date_value" :end_date="end_date_value" :dateError="dateError"></inventory-per-cross-sell>
      </v-lazy>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service"
import moment from "moment"
import InventoryPerWorkArea from './InventoryPerWorkArea.vue'
import InventoryPerClient from './InventoryPerClient.vue'
import InventoryPerCrossSell from './InventoryPerCrossSell.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: "Inventory",
  components: {
    InventoryPerWorkArea,
    InventoryPerClient,
    InventoryPerCrossSell
  },
  data: () => ({
    menu1: false,
    menu2: false,
    no_data: [null, "", undefined, "null"],
    start_date: moment().subtract(7, "d").format("YYYY[-]MM[-]DD"),
    end_date: moment().format("YYYY[-]MM[-]DD"),
    start_date_value: moment().subtract(7, "d").format("YYYY[-]MM[-]DD"),
    end_date_value: moment().format("YYYY[-]MM[-]DD"),
    clients: [],
    clientsLoading: false,
  }),
  mounted () {
    this.clientAndLocationsList()
    if (!this.no_data.includes(this.inventoryTableData)) {
      this.start_date = this.inventoryTableData.start_date_value
      this.start_date_value = this.inventoryTableData.start_date_value
      this.end_date = this.inventoryTableData.end_date_value 
      this.end_date_value = this.inventoryTableData.end_date_value 
    }
  },
  methods: {
    ...mapActions(['setTableData']),
    clientAndLocationsList() {
      this.clientsLoading = true;
      return new Promise((resolve, reject) => {
        ApiService.get("/commercial/location/select", { status: 'active,inactive' })
          .then(response => {
            const clients = response.data.commercial_locations
            let groupedClients = _.groupBy(clients, 'commercial_client_id')
            groupedClients = Object.values(groupedClients).map(client => {
              return [
                ...client,
                {
                  commercial_client_id: client[0].commercial_client_id,
                  commercial_customer_name: client[0].commercial_customer_name,
                  commercial_location_name: 'All Locations',
                }
              ]
            })
            this.clients = groupedClients.flat()
            this.clientsLoading = false;
            resolve()
          })
          .catch(error => {
            console.log(error);
            this.clientsLoading = false
            reject()
          })
      })
    },
    resetFilters() {
      this.start_date = moment().subtract(7, "d").format("YYYY[-]MM[-]DD")
      this.end_date = moment().format("YYYY[-]MM[-]DD")
      this.applyFilters()
    },
    applyFilters() {
      this.start_date_value = this.start_date
      this.end_date_value = this.end_date
      let data = {
        start_date_value: this.start_date_value,
        end_date_value: this.end_date_value
      }
      this.setTableData({key: 'inventoryTableData', value: data})
    }
  },
  computed: {
    ...mapGetters(['inventoryTableData']),
    minDate: function() {
      return moment().subtract(1, "y").format('YYYY[-]MM[-]DD')
    },
    maxDate: function() {
      return moment().format('YYYY[-]MM[-]DD')
    },
    dateError: function() {
      let error = ''
      if(this.no_data.includes(this.start_date) || this.no_data.includes(this.end_date)) {
        error = 'From Date and To Date fields are required'
      } else if (moment(this.start_date).isAfter(moment(this.end_date))) {
        error = 'From Date must be before To Date. Please correct selected dates.'
      } else {
        error = ''
      }
      return error
    }
  }
};
</script>

<style>

.inventory-reports-wrap .header-search-single {
  padding-bottom: 10px;
}

.inventory-reports-wrap .clear-filters {
  text-transform: none;
  color: #00838F;
  cursor: pointer;
  text-decoration: underline;
  font-size: 13px;
}

</style>